const ProfitAndLossTypes = {
	/** ***************** GET PROFIT-AND-LOSS START *********************** */
	GET_PROFIT_AND_LOSS_START: 'add_profit_and_loss_start',
	GET_PROFIT_AND_LOSS_SUCCESS: 'add_profit_and_loss_success',
	GET_PROFIT_AND_LOSS_FAILURE: 'add_profit_and_loss_failure',
	GET_PROFIT_AND_LOSS_RESPONSE_RESET: 'add_profit_and_loss_response_reset',
	GET_PROFIT_AND_LOSS_RESPONSE_CHANGED: 'add_profit_and_loss_response_changed',
	/** ***************** GET PROFIT-AND-LOSS END *********************** */
};
export default ProfitAndLossTypes;
